import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { lazy, Suspense } from 'react';

export interface PageComponentProps {
  id: string;
  data?: any;
  page?: string;
}

// Map of body class to dynamic import
const componentMap: {
  [key: string]: () => Promise<{ default: React.FC<PageComponentProps> }>;
} = {

  home: () => import('@pages/Home'),
  category: () => import('@pages/Home'),
  templateRegister: () => import('@pages/TemplateRegister'),
  templateIntake: () => import('@pages/TemplateIntake'),
};

// Convert body class to camelCase
function normalizeClass(className: string): string {
  return className
    .toLowerCase()
    .replace(/-/g, '_')
    .split('_')
    .map((word, i) =>
      i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('');
}

const getMatchedComponent = () => {
  const rawBodyClasses = document.body.className.split(/\s+/);
  const bodyClasses = rawBodyClasses.map(normalizeClass);

  bodyClasses.sort((a, b) => b.length - a.length);
  for (const className of bodyClasses) {
    if (componentMap[className]) {
      return {
        Component: lazy(componentMap[className]),
        key: className,
      };
    }
  }
  return null;
};

export const PageBodyComponents: React.FC = () => {
  const match = getMatchedComponent();
  if (!match) {
    return <div>Component not found for current page.</div>;
  }

  const queryClient = new QueryClient();
  const { Component, key } = match;
  console.log(window?.wpData);
  return (
    <Suspense>
      <QueryClientProvider client={queryClient}>
        <Component key={key} {...(window?.wpData || {})} />
      </QueryClientProvider>
    </Suspense>
  );
};
